"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no assignment with a given id exists
 * @param {string} assignmentId
 */
class AssignmentDoesNotExistError extends client_library_1.ExtendableError {
    constructor(id) {
        super(`assignment: id ${id} does not exist`);
        this.id = id;
    }
}
exports.default = AssignmentDoesNotExistError;
//# sourceMappingURL=AssignmentDoesNotExistError.js.map